import useNitroViewport from './customHooks/nitroHooks';
import TheEnd from './components/TheEnd';
import SurveyWrapper from './components/SurveyWrapper';
import PageNotFound from './components/PageNotFound';

import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

import './sass/Nitro.scss';

const App = () => {

  const { orientation } = useNitroViewport();

  // Tailwind min-h-screen is buggy on mobile, because it uses 100vh
  // which doesn't account for browser address bars.
  // The solution below is from https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
  // It also relies upon the min-h-screen class override in Nitro.scss

  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // We listen to the resize event
  window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });

  return (
    <div className={orientation}>
    <Router>
      <Routes>
        <Route path="/" element={<SurveyWrapper />} exact>
          <Route path=":uid" element={<SurveyWrapper />} />
        </Route>
        <Route exact path="/end" element={<TheEnd />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>

    </Router>
    </div>

  );

}

export default App;
